export const appstoreCardSyles = {
  appCard: {
    background: "#F3A35C",
  },
  content: {
    display: "flex",
    justifyContent: "space-between",
  },
  showMore: {
    display: "flex",
  },
  description: {
    color: "#FFFFFF",
  },
  info: {
    fontWeight: 500,
    fontSize: "22px",
    lineHeight: "27px",
    marginBottom: "13px",
  },
  moreInfo: {
    fontWeight: 400,
    fontSize: "17px",
    lineHeight: "20px",
    textDecorationLine: "underline",
    marginRight: "12px",
    cursor: "pointer",
  },
  logo: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "37px",
    cursor: "pointer",
  },
};
